import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  padding-block: ${spacing(1, 1.5)};
  padding-inline: ${spacing(2)};
`

export const info = css`
  inline-size: 100%;
  max-inline-size: ${spacing(66.75)};
`

export const numbers = css`
  background-color: ${cssTheme.colors.warmGray['100']};
  border-radius: 50%;
  margin-inline-end: ${spacing(1.5)};
`

export const point = css`
  padding-block: ${spacing(1.5)};
`

export const infoMobile = css`
  padding: ${spacing(1.5, 1.25, 0, 1.5)};
`
